import { render, staticRenderFns } from "./MinoreDettaglioEdit.vue?vue&type=template&id=a0feb9a8"
import script from "./MinoreDettaglioEdit.vue?vue&type=script&lang=js"
export * from "./MinoreDettaglioEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports